import { worldViewerWindow } from './const';
import { getUseSkywayAudioGainToggle } from './logics/dataOps';
export class CHELSkywayPlayer {
    release() {}
    getPeerId() {
        return this.peerId;
    }
    setStream(stream) {
        const useSkywayAudioGainToggle = getUseSkywayAudioGainToggle();
        if (!useSkywayAudioGainToggle) {
            return;
        }
        const audioTrack = stream.getAudioTracks()[0];
        if (audioTrack == null) {
            return;
        }
        const audio = document.createElement('audio');
        audio.srcObject = new MediaStream([
            audioTrack
        ]);
        audio.muted = true;
        audio.play();
        audio.style.display = 'none';
        document.getElementById('status').appendChild(audio);
        if (this.context !== undefined) {
            this.source = this.context.createMediaStreamSource(new MediaStream([
                audioTrack
            ]));
            this.audioDestination = this.context.createMediaStreamDestination();
        }
        if (this.gainNode !== undefined && this.audioDestination !== undefined && this.source !== undefined) {
            this.source.connect(this.gainNode);
            this.gainNode.connect(this.audioDestination);
        }
        stream.removeTrack(audioTrack);
        if (this.audioDestination !== undefined) {
            stream.addTrack(this.audioDestination.stream.getAudioTracks()[0]);
        }
    }
    setVolume(volume) {
        this.volume = volume;
        this.updateVolume();
    }
    SetVoiceAttenuate(volume) {
        this.attenuateVolume = volume;
        this.updateVolume();
    }
    SetMute(mute) {
        this.mute = mute;
        this.updateVolume();
    }
    updateVolume() {
        const useSkywayAudioGainToggle = getUseSkywayAudioGainToggle();
        if (!useSkywayAudioGainToggle) {
            return;
        }
        if (this.gainNode !== undefined) {
            this.gainNode.gain.value = this.volume * this.attenuateVolume * (this.mute ? 0.0 : 1.0);
        }
    }
    constructor(peerId, volume){
        this.peerId = peerId;
        const useSkywayAudioGainToggle = getUseSkywayAudioGainToggle();
        if (useSkywayAudioGainToggle) {
            this.context = new (worldViewerWindow.AudioContext || worldViewerWindow.webkitAudioContext)();
            if (this.context !== undefined) {
                this.gainNode = this.context.createGain();
            }
        }
        this.volume = volume;
        this.attenuateVolume = 1.0;
        this.mute = false;
        this.updateVolume();
    }
}
